import { ApplicationConfig, ApplicationSection, FieldType } from '@bybeam/platform-types';

const SECTIONS: ApplicationSection[] = [
  {
    key: 'learnMore',
    name: '1 Million Black Business',
    overview: {
      description: 'Learn more about this program',
      title: '1 Million Black Business',
    },
    questionGroups: [
      {
        key: 'learnMore',
        name: '1 Million Black Business',
        questions: [
          {
            key: 'link',
            copy: { title: '1 Million Black Business' },
            layout: 'panel',
            fields: [
              {
                key: 'link',
                type: FieldType.Typography,
                copy: `
The 1 Million Black Business Initiative (1MBB) by Operation Hope was created to support 1 million Black-owned businesses across the country by 2030. The free program can provide access to:
- Mentors
- Small Business Development Training Program
- 1:1 coaching in the areas of marketing, financing, business planning, and more
- Free trial to Shopify’s commerce platform

To sign-up, visit [https://portal.operationhope.org](https://portal.operationhope.org/) and use access code **KC816**. 
                `,
                props: { variant: 'largeBody', alignment: 'left' },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'attestation',
    name: 'Attestation',
    overview: {
      title: 'Attestation',
      description: '',
    },
    questionGroups: [
      {
        key: 'attestation',
        name: 'Attestation',
        questions: [
          {
            key: 'attestation',
            copy: { title: 'Attestation' },
            layout: 'panel',
            fields: [
              {
                key: 'attestation.info',
                type: FieldType.Typography,
                copy: 'I understand that to apply for this program, I must visit the external site: [https://portal.operationhope.org/](https://portal.operationhope.org/)',
                props: { variant: 'largeBody', alignment: 'center' },
              },
              {
                key: 'attestation.confirm',
                type: FieldType.Checkbox,
                copy: 'I confirm.',
              },
            ],
          },
        ],
      },
    ],
  },
];

const CONFIG: ApplicationConfig = {
  introPages: [],
  overrides: {
    statuses: [
      {
        status: 'Application',
        label: '',
        message:
          'This is an external program with its own application. To apply, visit [https://portal.operationhope.org/](https://portal.operationhope.org/) and use the access code KC816 to register.',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
      {
        status: 'InProgress',
        label: '',
        message:
          'This is an external program with its own application. To learn more & apply, visit [https://portal.operationhope.org/](https://portal.operationhope.org/) and use the access code KC816 to register.',
        referralMessage: 'You have been referred to this program.',
        action: 'Click here to learn more',
      },
    ],
    submission: {
      title: 'What happens next?',
      bullets: [
        {
          key: 'review',
          title: 'Application review',
          icon: 'description',
          description:
            'While we look at your application, we might send you an email to ask for more information or notify you of next steps',
        },
      ],
    },
  },
  sections: SECTIONS,
};

export default CONFIG;
